import React, { useState } from "react";

import { useSearchParams } from "utils";

import { MainPage, Tabs } from "components";

import { SoilSightSingleVersionOutcomes } from "pages/admin/soilSight/components/single/SoilSightSingleVersionOutcomes.tsx";
import { SoilSightSingleVersionReviews } from "pages/admin/soilSight/components/single/SoilSightSingleVersionReviews.tsx";

export const SoilSightSingleVersionPage = () => {
  const [activeTab, setActiveTab] = useState("version");
  const [, setSearchParams] = useSearchParams();

  const tabItems = [
    { key: "version", label: "Version", children: <SoilSightSingleVersionOutcomes /> },
    {
      key: "reviews",
      label: "Reviews",
      children: (
        <SoilSightSingleVersionReviews
          onOpenVersion={(openedVersion) => {
            setActiveTab("version");
            setSearchParams({ version: openedVersion });
          }}
        />
      ),
    },
  ];

  return (
    <MainPage pageName="admin" className="padding-100">
      <Tabs activeKey={activeTab} size="small" onChange={setActiveTab} items={tabItems} />
    </MainPage>
  );
};
